import baseApi from './baseApi';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Login endpoint
    login: builder.mutation({
      query: (credentials) => ({
        url: '/identity/sign_in',
        method: 'POST',
        params: {
          broker: 'ZERODHA',
          request_token: credentials.requestToken || ''
        },
        body: credentials,
      }),
      transformResponse: (response) => {
        if (response?.access_token) {
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 1);
          document.cookie = `authToken=${response.access_token}; expires=${expirationDate.toUTCString()}; path=/`;
          localStorage.setItem("userID", response.userId);
        }
        return response;
      },
      invalidatesTags: ['Auth'],
    }),

    // Logout endpoint (client-side only since no server endpoint exists)
    logout: builder.mutation({
      queryFn: async () => {
        try {

          localStorage.removeItem("userID");
          document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

          return { data: { success: true, message: "Logged out successfully" } };
        } catch (error) {
          return { error: { message: "Logout failed" } };
        }
      },
      invalidatesTags: ['Auth'],
    }),

    // Get current user
    getCurrentUser: builder.query({
      query: (userId) => `/identity/users/${userId}`,
      providesTags: ['Auth'],
    }),

    // Verify OTP
    verifyOtp: builder.mutation({
      query: ({ otp, phoneNumber }) => ({
        url: '/auth/otp/verify',
        method: 'POST',
        body: { otp, phoneNumber },
      }),
      transformResponse: (response) => {
        if (response?.token) {
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 1);
          document.cookie = `authToken=${response.token}; expires=${expirationDate.toUTCString()}; path=/`;
          localStorage.setItem("userID", response.user?.Id);
        }
        return response;
      },
      invalidatesTags: ['Auth'],
    }),

    // Create user
    createUser: builder.mutation({
      query: ({ email, firstName, lastName, phoneNumber }) => ({
        url: '/users',
        method: 'POST',
        body: { email, firstName, lastName, phoneNumber },
      }),
      transformResponse: (response) => {
        if (response?.token) {
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 1);
          document.cookie = `authToken=${response.token}; expires=${expirationDate.toUTCString()}; path=/`;
          localStorage.setItem("userID", response.user?.Id);
        }
        return response;
      },
      invalidatesTags: ['Auth'],
    }),

    // Get user profile
    getUserProfile: builder.query({
      query: () => '/users/me',
      providesTags: ['UserProfile'],
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useGetCurrentUserQuery,
  useVerifyOtpMutation,
  useCreateUserMutation,
  useGetUserProfileQuery,
} = authApi;

export default authApi;
